import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import TextLink from './TextLink';
import LinkHeading from './LinkHeading';

const Wrapper = styled.div`

  ul {
    list-style: none;
    margin: 0;
    padding: 0;
    a{
      color: inherit;
      font-size: 1.2rem;
      display: flex;
      padding: ${({ theme }) => theme.spacing}px 0px;
      margin: 0;

      .text {
        flex-grow:1;
      }
    }
  }
`;

const ContactUs = ({
  className,
  storeUrl,
  isStartPage,
  customerServicePhoneNumber,
  contactUsLink,
}) => {
  const classes = ['ContactUs'];
  if (className) classes.push(className);

  if (!isStartPage && !storeUrl) {
    return (
      <Wrapper className={classes.join(' ')}></Wrapper>
    );
  }

  return (
    <Wrapper className={classes.join(' ')}>
      <LinkHeading title="Contact us" />
      <h4>We&apos;re here to help</h4>
      <ul>
        { isStartPage && (
          <>
            <li>
              <TextLink
                rightChevron
                component="a"
                props={{ href: contactUsLink, target: '_blank' }}
              >
                Send us feedback or get in touch
              </TextLink>
            </li>
            <li>
              <TextLink
                rightChevron
                component="a"
                props={{
                  href: `tel:${customerServicePhoneNumber.replace(/ /g, '')}`,
                }}
              >
                Call us on&nbsp;
                {customerServicePhoneNumber}
              </TextLink>
            </li>
          </>
        )}
        {storeUrl && (
          <li>
            <TextLink
              rightChevron
              component="a"
              props={{ href: storeUrl, target: '_blank' }}
            >
              Please contact your store
            </TextLink>
          </li>
        )}
      </ul>
    </Wrapper>
  );
};

ContactUs.displayName = 'ContactUs';

ContactUs.propTypes = {
  isStartPage: PropTypes.bool,
  className: PropTypes.string,
  storeUrl: PropTypes.string,
  customerServicePhoneNumber: PropTypes.string.isRequired,
  contactUsLink: PropTypes.string.isRequired,
};

ContactUs.defaultProps = {
  isStartPage: false,
  className: null,
  storeUrl: null,
};

export default ContactUs;
